import React from 'react';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import './Skills.css';

const Skills = () => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true
  });

  const skillCategories = [
    {
      title: 'AI & Machine Learning',
      skills: [
        'Computer Vision',
        'Deep Learning',
        'LangChain & RAG',
        'AI Agents',
        'Edge AI (TensorRT)',
        'NLP',
        'Reinforcement Learning'
      ]
    },
    {
      title: 'IoT & Embedded',
      skills: [
        'ESP32 & Arduino',
        'NVIDIA Jetson',
        'STM32 & AVR',
        'Sensor Integration',
        'MQTT & WebSockets',
        'BLE / LoRa / Zigbee',
        'PCB Design'
      ]
    },
    {
      title: 'Backend & DevOps',
      skills: [
        'Python & FastAPI',
        'Docker',
        'API Design',
        'PostgreSQL / MongoDB / Redis',
        'CI/CD (GitHub Actions)',
        'AWS & Azure'
      ]
    },
    {
      title: 'Languages & Tools',
      skills: [
        'Python',
        'C++ & Assembly',
        'JavaScript & React',
        'Git & Linux',
        'Bash',
        'Figma',
        'Cybersecurity'
      ]
    }
  ];

  return (
    <section id="skills" className="section section-alt">
      <div className="container">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 24 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          <div className="section-head">
            <span className="section-path">skills</span>
            <h2>Tools of the trade</h2>
          </div>

          <div className="skills-grid">
            {skillCategories.map((category, index) => (
              <motion.div
                key={index}
                className="skill-category"
                initial={{ opacity: 0, y: 24 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: 0.1 + index * 0.1 }}
              >
                <h3>{category.title}</h3>
                <div className="skills-list">
                  {category.skills.map((skill, skillIndex) => (
                    <span key={skillIndex} className="chip">{skill}</span>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
